import React, { useState, useEffect } from 'react';
import axios from 'axios';
import APIEndPoints from '../../../../middleware/APIEndPoints';

const ServiceCRUD = () => {
  const [services, setServices] = useState([]); // Fetch services
  const [newService, setNewService] = useState({ name: '', description: '', link: '' }); // Create a new service
  const [editService, setEditService] = useState(null); // Service to edit
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getServiceURl = APIEndPoints.services.url;

  // Fetch all services
  const fetchServices = async () => {
    try {
      setLoading(true);
      const res = await axios.get(getServiceURl);
      setServices(res.data); // Assuming the response has the list of services
    } catch (err) {
      setError('Error fetching services');
    } finally {
      setLoading(false);
    }
  };

  // Create a new service
  const handleCreateService = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(getServiceURl, newService);
      setServices([...services, res.data]); // Add the new service to the list
      setNewService({ name: '', description: '', link: '' }); // Clear form
    } catch (err) {
      setError('Error creating service');
    }
  };

  // Delete a service by ID
  const handleDeleteService = async (id) => {
    try {
      await axios.delete(`${getServiceURl}/${id}`);
      setServices(services.filter((service) => service._id !== id)); // Remove the service from the list
    } catch (err) {
      setError('Error deleting service');
    }
  };

  // Update a service by ID
  const handleUpdateService = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${getServiceURl}/${editService._id}`, editService);
      setServices(
        services.map((service) => (service._id === editService._id ? editService : service))
      );
      setEditService(null); // Clear edit form
    } catch (err) {
      setError('Error updating service');
    }
  };

  // Load services on component mount
  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <div className="bg-[#1d0c39]  min-h-screen p-8 text-white">
      <h1 className='text-2xl font-bold mb-4'>Services Management</h1>

      {/* Error & Loading State */}
      {loading && <p>Loading...</p>}
      {error && <p className='text-red-500'>{error}</p>}

      {/* Service List */}
      <div className='mb-8'>
        <h2 className='text-xl font-semibold mb-2'>All Services</h2>
        <ul>
          {services.map((service) => (
            <li key={service._id} className='border p-4 mb-2 flex justify-between'>
              <div>
                <h3 className='font-bold'>{service.name}</h3>
                <p>{service.description}</p>
                <a href={service.link} alt='website link'>learn more</a>
              </div>
              <div>
                <button
                  onClick={() => setEditService(service)}
                  className='bg-blue-500 text-white p-2 rounded mr-2'
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteService(service._id)}
                  className='bg-red-500 text-white p-2 rounded'
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Create Service */}
      <div className='mb-8'>
        <h2 className='text-xl font-semibold mb-2'>Create New Service</h2>
        <form onSubmit={handleCreateService} className='flex flex-col gap-4'>
          <input
            type='text'
            placeholder='Service Name'
            value={newService.name}
            onChange={(e) => setNewService({ ...newService, name: e.target.value })}
            className='border p-2'
            required
          />
          <input
            type='text'
            placeholder='Description'
            value={newService.description}
            onChange={(e) => setNewService({ ...newService, description: e.target.value })}
            className='border p-2'
            required
          />
          <input
            type='text'
            placeholder='Link'
            value={newService.link}
            onChange={(e) => setNewService({ ...newService, link: e.target.value })}
            className='border p-2'
            required
          />
          <button type='submit' className='bg-green-500 text-white p-2 rounded'>
            Add Service
          </button>
        </form>
      </div>

      {/* Update Service */}
      {editService && (
        <div>
          <h2 className='text-xl font-semibold mb-2'>Edit Service</h2>
          <form onSubmit={handleUpdateService} className='flex flex-col gap-4'>
            <input
              type='text'
              placeholder='Service Name'
              value={editService.name}
              onChange={(e) => setEditService({ ...editService, name: e.target.value })}
              className='border p-2'
              required
            />
            <input
              type='text'
              placeholder='Description'
              value={editService.description}
              onChange={(e) => setEditService({ ...editService, description: e.target.value })}
              className='border p-2'
              required
            />
            <input
              type='text'
              placeholder='Link'
              value={editService.link}
              onChange={(e) => setEditService({ ...editService, link: e.target.value })}
              className='border p-2'
              required
            />
            <button type='submit' className='bg-yellow-500 text-white p-2 rounded'>
              Update Service
            </button>
            <button
              onClick={() => setEditService(null)}
              className='bg-gray-500 text-white p-2 rounded mt-2'
            >
              Cancel
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default ServiceCRUD;
